import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import { initFilestackClient } from './initFilestackClient';

/**
 * Uploads a file to Filestack using the picker UI
 *
 * @return {Promise<object>} A Promise that resolves with the Filestack record
 * of the uploaded file
 */
async function filestackFileUpload() {
  const { client, uploadOptions, storeOptions } = await initFilestackClient(
    () => request.get(routes.ANSWER_UPLOAD_OPTIONS),
  );

  return new Promise((resolve, reject) => {
    const picker = client.picker({
      maxFiles: 1,
      accept: uploadOptions.extensions,
      maxSize: uploadOptions.max_size,
      fromSources: uploadOptions.services,
      startUploadingWhenMaxFilesReached: true,
      onUploadDone: response => resolve(response.filesUploaded[0]),
      onFileUploadFailed: (file, error) => reject(error),
      storeTo: storeOptions,
    });

    picker.open();
  });
}

export async function answerUploadToFilestack() {
  const filestackResponse = await filestackFileUpload();
  return filestackResponse;
}
